import Text from "./text.container";

export default Text;
